import React from 'react'
import styles from './styles.module.scss'

interface Props {
    onClick?(): void
    checked: boolean
    title?: string
    classNameContainer?: string
    classNameCheckbox?: string
    classNameTitle?: string
}

/** Componente de checkbox que segue o layout do MenuDino. */
export default function ActionCheckbox(props: Props) {
    return (
        <div onClick={props.onClick} className={`${styles.container} ${props.classNameContainer ?? ""}`}>
            <div className={`${styles.chk} ${props.checked && styles.chkActive} ${props.classNameCheckbox ?? ""}`} />
            {props.title && <span className={`${props.classNameTitle ?? ""} font-sm`}>{props.title}</span>}
        </div>
    )
}
